import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PrintComponent } from '../print/print.component';
import { ReferralDownloadComponent } from '../referral-download/referral-download.component';
import { More211servicesComponent } from '../more211services/more211services.component';


@Component({
  selector: 'app-food-service',
  templateUrl: './food-service.component.html',
  styleUrls: ['./food-service.component.css']
})
export class FoodServiceComponent implements OnInit {

  public foodServiceResp;
  public currentUser;
  public pincode;
  public foodSearchTerm;
  public foodPincode;
  public isMoreDetails: boolean;
  public userIdWithhoutSignup;
  public userSignup;
  public isAdditionalHelp;

  foodServiceForm = this
    .formBuilder
    .group({
      search_term: [
        '', Validators.required
      ],
      pincode: [
        '', Validators.required
      ]
    });


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.getFoodService();
  }

  additionalHelp(){
    this.isAdditionalHelp = true; 
    if(this.isAdditionalHelp == true){
      localStorage.setItem('isAdditionalHelp','true')
      this.router.navigate(['/food'])
    }
    
  }

  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu() {
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  navigateToReferral() {
    this.router.navigate(['/referral-download'])
  }

  getFoodService() {
    let userId;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userIdWithhoutSignup = localStorage.getItem('userIdWithhoutSignup');
    this.userSignup = localStorage.getItem('user_id');
    if (this.currentUser != null && this.currentUser != undefined) {
      userId = this.currentUser.data.user_id
    }
    else if (this.userIdWithhoutSignup != null && this.userIdWithhoutSignup != undefined) {
      userId = this.userIdWithhoutSignup
    }
    else if (this.userSignup != null && this.userSignup != undefined) {
      userId = this.userSignup
    }
    else {
      userId = "";
    }
    this.foodSearchTerm = localStorage.getItem('Eservice');
    this.foodPincode = localStorage.getItem('EservicePincode')
    // this.pincode = this.currentUser.zip_code;
    let input: {}
    input = {
      search_term: this.foodSearchTerm,
      pincode: this.foodPincode,
      user_id: userId
    }

    this.commonService.searchFoodService(input).subscribe(res => {
      this.foodServiceResp = res.body.data;
      console.log(this.foodServiceResp, 'foodresp')
    })
  }

  moreDetails(i) {
    console.log('inside more details index', i)
    this.isMoreDetails = true
  }

  lessDetails() {
    this.isMoreDetails = false

  }



  getDirections(lat, long) {
    var map = "https://maps.google.com/?q=" + lat + ',' + long;
    window.open(map);
    console.log(map);
  }

  openDialog(action: any, obj: any, element: any, i: any) {
    const dialogConfig = new MatDialogConfig();
    obj.action = action;
    obj.index = i;
    if (element != null) {
      obj.id = element;
    }
    obj.htmlData = document.getElementById("card_" + i);
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = obj;
    let dialogRef;
    if (action === 'print') {
      dialogRef = this.dialog.open(PrintComponent, dialogConfig);
    }
    if (action === 'referral') {
      dialogRef = this.dialog.open(ReferralDownloadComponent, dialogConfig);
    }
    if (action === 'services') {
      dialogRef = this.dialog.open(More211servicesComponent, dialogConfig);
    }



    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'print' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
      if (result.event === 'referral' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
      if (result.event === 'services' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
    });
  }

  showNotification(from, align, color, stringMessage, icons) {
    const type = ['', 'info', 'success', 'warning', 'danger'];



    // $.notify({
    //   icon: icons,
    //   message: stringMessage

    // }, {
    //   type: type[color],
    //   timer: 4000,
    //   placement: {
    //     from: from,
    //     align: align
    //   },
    //   template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
    //     '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
    //     '<i class="material-icons" data-notify="icon">notifications</i> ' +
    //     '<span data-notify="title">{1}</span> ' +
    //     '<span data-notify="message">{2}</span>' +
    //     '<div class="progress" data-notify="progressbar">' +
    //     '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
    //     '</div>' +
    //     '<a href="{3}" target="{4}" data-notify="url"></a>' +
    //     '</div>'
    // });
  }

}
